import React from "react"
import types from "prop-types"
import Sidebar from "shared/Sidebar"
import SubmissionAnswerLocationFilter from "./SubmissionAnswerLocationFilter"
import SubmissionCategoryFilter from "./SubmissionCategoryFilter"
import SubmissionFormFilter from "./SubmissionFormFilter"
import SubmissionGroupBy from "./SubmissionGroupBy"
import SubmissionColumnSelector from "./SubmissionColumnSelector"
import SubmissionClosedFilter from "./SubmissionClosedFilter"
import SubmissionDeletedFilter from "./SubmissionDeletedFilter"

const SubmissionSidebar = ({ hiddenSidebar }) => (
  <Sidebar hiddenSidebar={hiddenSidebar}>
    <SubmissionCategoryFilter />
    <SubmissionClosedFilter />
    <SubmissionDeletedFilter />
    <SubmissionFormFilter />
    <SubmissionAnswerLocationFilter />
    <SubmissionGroupBy />
    <SubmissionColumnSelector />
  </Sidebar>
)

SubmissionSidebar.propTypes = {
  hiddenSidebar: types.bool.isRequired,
}

export default SubmissionSidebar
